import React from 'react';
import { SimpleButton } from './SimpleButton';

const ButtonScogoPrimaryOutlined = ({
    btnimgClass = 'w-4 h-4 mr-1 ',
    buttonIcon,
    Btnalt = 'img',
    textOrComponent,
    onClick,
    loading,
    buttonClass = '',
    disabled = false,
    buttonIconComponent,
    loaderColor,
    disabledClass = 'text-black flex items-center justify-center rounded-6px shadow-primaryBtnShadow text-xl gap-1 font-medium relative cursor-not-allowed border-scogoddd bg-scogoddd',
    buttonPadding = 'px-4 py-2',
    loaderClass,
}) => {
    if (!disabled) disabled = loading;

    const btnClass = disabled
        ? `${disabledClass} ${buttonPadding}`
        : `text-scogoprimary whitespace-nowrap bg-white font-medium text-font11 flex items-center justify-center rounded-5px border border-scogoprimary  ${buttonClass} ${buttonPadding}`;

    return (
        <SimpleButton
            loading={loading}
            btnClass={btnClass}
            onClick={onClick}
            disabled={disabled}
            loaderColor={loaderColor}
            buttonIcon={buttonIcon}
            buttonIconComponent={buttonIconComponent}
            btnimgClass={btnimgClass}
            Btnalt={Btnalt}
            textOrComponent={textOrComponent}
            loaderClass={loaderClass}
        />
    );
};

export default ButtonScogoPrimaryOutlined;
